import React, { FC, useEffect, useState } from "react";
import { Box, Modal as MuiModal } from "@mui/material";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import MDButton from "mdComponents/MDButton";
import MDInput from "mdComponents/MDInput";
import { CorporateAccountAdmin } from "../models/corporateAccountAdminModel";
import { formatDate } from "../Utils";

interface CorporateAdminDetailsModalProps {
  selectedItem?: CorporateAccountAdmin;
  editMode: boolean;
  visible: boolean;
  onSaveChanges: (changed: CorporateAccountAdmin) => void;
  onDone: () => void;
}

const CorporateAdminDetailsModal: FC<CorporateAdminDetailsModalProps> = ({
  selectedItem,
  visible,
  editMode,
  onSaveChanges,
  onDone,
}) => {
  const [email, setEmail] = useState<string>("");

  // Reset form on open
  useEffect(() => {
    if (visible) {
      setEmail(editMode ? selectedItem?.email || "" : "");
    }
  }, [visible, editMode, selectedItem]);

  const updateClick = () => {
    const newItem = {
        ...selectedItem,
        email
    };
    onSaveChanges(newItem);
  };

  return (
    <MuiModal open={visible} onClose={() => {}}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          p: 4,
          width: 450,
          maxWidth: "95%",
          borderRadius: 2,
          boxShadow: 24,
        }}
      >
        <MDTypography variant="h5" fontWeight="medium" mb={2}>
          {editMode ? "Edit Account Admin" : "Add Account Admin"}
        </MDTypography>

        <MDBox display="flex" flexDirection="column" gap={2}>
          <MDTypography variant="button" fontWeight="medium">
            Email
          </MDTypography>
          <MDInput
            fullWidth
            value={email}
            name="email"
            onChange={(e: any) => setEmail(e.target.value)}
            type="email"
          />

        </MDBox>
        {/* Action Buttons */}
        <MDBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
            <MDButton variant="outlined" color="secondary" onClick={onDone}>
            Cancel
            </MDButton>
            <MDButton color="info" onClick={updateClick}>
            {editMode ? "Update" : "Save"}
            </MDButton>
        </MDBox>
      </Box>
    </MuiModal>
  );
};

export default CorporateAdminDetailsModal;
